// extracted by mini-css-extract-plugin
export default {"surveyNumberInput":"surveyInput_surveyNumberInput__vI371","label_text":"surveyInput_label_text__7MI6Y","surveyInputContainer":"surveyInput_surveyInputContainer__313nm"};